import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AppConfigResourceApi} from "../../../shared/services/api/app-config-resource.api";

@Injectable()
export class SupportService {
  constructor(private appConfigResourceApi: AppConfigResourceApi) {
  }

  getAppConfigs(): Observable<any> {
    return this.appConfigResourceApi.get();
  }

  getAppConfigById(key, subKey): Observable<any> {
    return this.appConfigResourceApi.getById(key, subKey);
  }

  addConfig(body: Object): Observable<any> {
    return this.appConfigResourceApi.post(body);
  }

  deleteConfigById(key, subKey): Observable<any> {
    return this.appConfigResourceApi.deleteById(key,subKey);
  }

}

//http://localhost:8180/pension/api/fundswitching/changeInvestment?riskProfile=AGGRESSIVE&language=EN api/fundswitching/update?riskProfile=AGGRESSIVE
//api/fundswitching/history?fsId=rerer&empId&fDate&tDate&status&rProf
